import { render, staticRenderFns } from "./MessageBox.vue?vue&type=template&id=7c4ca54d&scoped=true"
import script from "./MessageBox.vue?vue&type=script&lang=ts"
export * from "./MessageBox.vue?vue&type=script&lang=ts"
import style0 from "./MessageBox.vue?vue&type=style&index=0&id=7c4ca54d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4ca54d",
  null
  
)

export default component.exports